// extracted by mini-css-extract-plugin
module.exports = {"pageHome":"Home_pageHome__qvySa","ant_table":"Home_ant_table__3dmiR","a_table_tag":"Home_a_table_tag__ur-Fl","dividerSmall":"Home_dividerSmall__3A7Wc"};